var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBlackboard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4802_106346)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M87.1938 76.5021H2.80624C1.25647 76.5021 0 75.2456 0 73.6957V16.3043C0 14.7543 1.25647 13.498 2.80624 13.498H87.1936C88.7435 13.498 89.9998 14.7545 89.9998 16.3043V73.6959C90 75.2456 88.7435 76.5021 87.1938 76.5021Z",
    fill: "url(#paint0_linear_4802_106346)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.7795 75.0799H4.22649C2.73796 75.0799 1.53125 73.8732 1.53125 72.3847V17.6153C1.53125 16.1268 2.73796 14.92 4.22649 14.92H85.7794C87.2679 14.92 88.4746 16.1268 88.4746 17.6153V72.3847C88.4748 73.8732 87.2681 75.0799 85.7795 75.0799Z",
    fill: "url(#paint1_linear_4802_106346)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.1571 76.5021L30.9483 69.2933L30.3125 69.0984V76.5021H38.1571Z",
    fill: "url(#paint2_linear_4802_106346)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.3966 72.3427H6.59993C5.35387 72.3427 4.34375 71.3326 4.34375 70.0865V19.9136C4.34375 18.6676 5.35387 17.6575 6.59993 17.6575H83.3966C84.6426 17.6575 85.6528 18.6676 85.6528 19.9136V70.0865C85.6528 71.3326 84.6426 72.3427 83.3966 72.3427Z",
    fill: "url(#paint3_linear_4802_106346)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6452 17.6573H6.59993C5.35387 17.6573 4.34375 18.6675 4.34375 19.9135V70.0864C4.34375 71.3325 5.35387 72.3426 6.59993 72.3426H11.6452V17.6573Z",
    fill: "url(#paint4_linear_4802_106346)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.3964 17.6573H6.59993C5.35387 17.6573 4.34375 18.6675 4.34375 19.9135V24.0001H85.6529V19.9137C85.6528 18.6675 84.6426 17.6573 83.3964 17.6573Z",
    fill: "url(#paint5_linear_4802_106346)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.8286 69.7134H9.17378C8.03801 69.7134 7.11719 68.7926 7.11719 67.6569V22.3431C7.11719 21.2073 8.03801 20.2865 9.17378 20.2865H80.8286C81.9644 20.2865 82.8852 21.2073 82.8852 22.3431V67.6569C82.8852 68.7926 81.9644 69.7134 80.8286 69.7134Z",
    fill: "url(#paint6_linear_4802_106346)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.9977 72.3427L30.9483 69.2933L30.3125 69.0984V72.3427H33.9977Z",
    fill: "url(#paint7_linear_4802_106346)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9004 69.3861C23.9004 70.455 23.0338 71.3216 21.9649 71.3216H13.7477C12.6788 71.3216 11.8122 70.4552 11.8122 69.3861C11.8122 69.2273 11.6833 69.0984 11.5245 69.0984H5.36657C4.80169 69.0984 4.34375 69.5564 4.34375 70.1213V75.4793C4.34375 76.0442 4.80169 76.5021 5.36657 76.5021H30.346C30.9109 76.5021 31.3688 76.0442 31.3688 75.4793V70.1213C31.3688 69.5564 30.9109 69.0984 30.346 69.0984H24.188C24.0292 69.0984 23.9004 69.2273 23.9004 69.3861Z",
    fill: "url(#paint8_linear_4802_106346)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.40625 74.7217V70.8787C5.40625 70.4808 5.72884 70.1582 6.12678 70.1582H10.348C10.6349 70.1582 10.8925 70.3292 11.0085 70.5916C11.4733 71.6444 12.5275 72.3814 13.7505 72.3814H21.9677C23.1906 72.3814 24.2447 71.6446 24.7095 70.5916C24.8254 70.3292 25.0831 70.1582 25.37 70.1582H29.5912C29.9891 70.1582 30.3117 70.4808 30.3117 70.8787V74.7217C30.3117 75.1197 29.9891 75.4423 29.5912 75.4423H6.12678C5.72884 75.4423 5.40625 75.1197 5.40625 74.7217Z",
    fill: "url(#paint9_linear_4802_106346)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.3446 76.5021C30.9095 76.5021 31.3675 76.0442 31.3675 75.4793V70.1213C31.3675 69.7803 31.2 69.4791 30.9434 69.2933L13.2969 76.5021H30.3446Z",
    fill: "url(#paint10_linear_4802_106346)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2578 54.2769C11.2578 54.2003 11.283 54.06 11.3348 53.8548L18.473 30.4442C18.6775 29.805 19.1446 29.3121 19.8738 28.9666C20.6028 28.6213 21.4407 28.4485 22.3875 28.4485C23.3335 28.4485 24.1719 28.6213 24.9011 28.9666C25.6305 29.3121 26.0967 29.805 26.3021 30.4442L33.4786 53.8548C33.5296 54.0598 33.5556 54.2001 33.5556 54.2769C33.5556 54.9427 33.1396 55.5184 32.3083 56.004C31.4766 56.4904 30.6133 56.7332 29.7177 56.7332C28.6176 56.7332 27.965 56.3624 27.7605 55.6202L26.4558 50.8228H18.3579L17.0529 55.6202C16.8479 56.3624 16.1956 56.7332 15.0957 56.7332C14.1999 56.7332 13.3361 56.4904 12.5051 56.004C11.6736 55.5184 11.2578 54.9425 11.2578 54.2769ZM19.586 46.2175H25.1891L22.3876 35.9323L19.586 46.2175Z",
    fill: "url(#paint11_linear_4802_106346)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.0156 54.9292V30.5209C37.0156 29.9325 37.271 29.4787 37.7833 29.1584C38.2947 28.8388 38.9088 28.6787 39.6254 28.6787H47.4929C52.6098 28.6787 55.1685 30.9561 55.1685 35.5099C55.1685 38.5801 54.0807 40.5891 51.9064 41.5355C53.2114 42.0218 54.1959 42.7191 54.8616 43.6268C55.5265 44.5355 55.8593 45.8853 55.8593 47.6758V48.4817C55.8593 51.3472 55.1617 53.4391 53.7676 54.7565C52.373 56.0745 50.4989 56.7329 48.1455 56.7329H39.6256C38.8322 56.7329 38.199 56.5542 37.7257 56.1958C37.2519 55.8379 37.0156 55.4156 37.0156 54.9292ZM42.9643 39.2327H46.994C47.6849 39.2327 48.222 38.9708 48.6059 38.446C48.9897 37.9219 49.1815 37.3012 49.1815 36.5846C49.1815 35.8687 48.9897 35.2415 48.6059 34.7041C48.222 34.1668 47.6849 33.8984 46.994 33.8984H42.9643V39.2327ZM42.9643 51.5137H46.8022C48.8487 51.5137 49.8722 50.3373 49.8722 47.9828V47.3689C49.8722 45.0151 48.8485 43.8381 46.8022 43.8381H42.9643V51.5137Z",
    fill: "url(#paint12_linear_4802_106346)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.8984 47.9061V37.7359C59.8984 34.6147 60.7487 32.3247 62.4506 30.8661C64.1519 29.4078 66.3712 28.6786 69.1091 28.6786C71.9231 28.6786 74.2324 29.3568 76.0365 30.7126C77.8402 32.0689 78.7421 33.9364 78.7421 36.3157C78.7421 37.416 78.5117 38.1646 78.0513 38.5609C77.5907 38.9578 76.823 39.1557 75.7485 39.1557C73.8296 39.1557 72.8318 38.5549 72.755 37.3519C72.6783 35.0492 71.5395 33.8981 69.3394 33.8981C67.0368 33.8981 65.8854 35.1776 65.8854 37.7358V47.9059C65.8854 50.4646 67.0494 51.7436 69.3779 51.7436C70.0939 51.7436 70.6887 51.6286 71.1624 51.3983C71.6355 51.168 71.9741 50.8167 72.1794 50.343C72.3839 49.8699 72.5182 49.4797 72.5823 49.1725C72.646 48.8654 72.7037 48.4433 72.755 47.9059C72.8569 46.7035 73.8423 46.1021 75.71 46.1021C76.8098 46.1021 77.5905 46.3006 78.0513 46.6969C78.5117 47.094 78.7421 47.8422 78.7421 48.9422C78.7421 51.4241 77.8402 53.3815 76.0365 54.8139C74.2324 56.247 71.9231 56.9631 69.1091 56.9631C66.371 56.9631 64.1517 56.2339 62.4506 54.7756C60.7489 53.3174 59.8984 51.0281 59.8984 47.9061Z",
    fill: "url(#paint13_linear_4802_106346)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.9376 63.0323C66.771 62.8052 66.5459 62.6163 66.2702 62.4935L61.2731 60.2672C60.4273 59.8904 59.4362 60.2705 59.0594 61.1163C58.7321 61.8513 58.9767 62.6954 59.6012 63.1514L68.7925 72.3427H76.248L66.9376 63.0323Z",
    fill: "url(#paint14_linear_4802_106346)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.1195 64.7072C66.7427 65.553 65.7517 65.9331 64.9059 65.5563L59.9087 63.33C59.0629 62.9532 58.6828 61.9621 59.0596 61.1163C59.4363 60.2705 60.4274 59.8904 61.2732 60.2672L66.2703 62.4935C67.1162 62.8703 67.4963 63.8615 67.1195 64.7072Z",
    fill: "url(#paint15_linear_4802_106346)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4802_106346",
    x1: 39.5082,
    y1: 31.1061,
    x2: 68.8114,
    y2: 105.241,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDA45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA425"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4802_106346",
    x1: 82.0618,
    y1: 82.0588,
    x2: -23.9794,
    y2: -23.9824,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDA45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA425"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4802_106346",
    x1: 37.6897,
    y1: 79.224,
    x2: 26.925,
    y2: 69.5769,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDA45",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B53759"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_4802_106346",
    x1: 40.1533,
    y1: 32.7431,
    x2: 66.0043,
    y2: 98.1438,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7E8595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#555A66"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_4802_106346",
    x1: 9.3511,
    y1: 45.0001,
    x2: 2.29016,
    y2: 45.0001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#555A66",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#555A66"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_4802_106346",
    x1: 44.9982,
    y1: 22.9412,
    x2: 44.9982,
    y2: 15.4772,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#555A66",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#555A66"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_4802_106346",
    x1: 48.7487,
    y1: 53.0613,
    x2: 0.836239,
    y2: -50.0037,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BEC3D2",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.221,
    stopColor: "#C5C9D7",
    stopOpacity: 0.221
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5343,
    stopColor: "#D7DAE3",
    stopOpacity: 0.534
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9014,
    stopColor: "#F6F6F8",
    stopOpacity: 0.901
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_4802_106346",
    x1: 34.3263,
    y1: 74.5138,
    x2: 30.2866,
    y2: 70.474,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#555A66",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#555A66"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_4802_106346",
    x1: 17.0272,
    y1: 69.9206,
    x2: 19.5335,
    y2: 78.6261,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDA45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA425"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_4802_106346",
    x1: 17.3189,
    y1: 72.095,
    x2: 11.5541,
    y2: 64.5655,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDA45",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCEE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_4802_106346",
    x1: 22.5978,
    y1: 74.392,
    x2: 24.8232,
    y2: 60.6416,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDA45",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B53759"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_4802_106346",
    x1: 15.9038,
    y1: 30.5333,
    x2: 27.1979,
    y2: 71.8273,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9F7FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0DDFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_4802_106346",
    x1: 40.4854,
    y1: 24.1477,
    x2: 51.7795,
    y2: 65.4418,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9F7FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0DDFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_4802_106346",
    x1: 62.7345,
    y1: 18.4011,
    x2: 74.0286,
    y2: 59.6954,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9F7FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0DDFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_4802_106346",
    x1: 68.3714,
    y1: 70.2254,
    x2: 66.5185,
    y2: 63.0783,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#555A66",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#555A66"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_4802_106346",
    x1: 55.4413,
    y1: 61.767,
    x2: 68.3641,
    y2: 63.7514,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9F7FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0DDFC"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4802_106346"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 90,
    height: 90,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlackboard);
export default __webpack_public_path__ + "static/media/blackboard.6abeb424e7b8ba011046c36ccdd1830e.svg";
export { ForwardRef as ReactComponent };